import { FeatureFlag } from 'src/constants/feature-flag';

export const CLIENT_PORTAL_SURFACES = [
  'shell',
  'home',
  'yourTeam',
  'tasks',
  'investments',
  'accounts',
  'tax',
  'documents',
  'planning',
  'accountProfile',
  'support',
] as const;

export type ClientPortalSurface = (typeof CLIENT_PORTAL_SURFACES)[number];

export const CLIENT_PORTAL_SURFACE_FLAGS: Record<ClientPortalSurface, FeatureFlag> = {
  shell: FeatureFlag.ClientPortalRedesignShell,
  home: FeatureFlag.ClientPortalRedesignHome,
  yourTeam: FeatureFlag.ClientPortalRedesignYourTeam,
  tasks: FeatureFlag.ClientPortalRedesignTasks,
  investments: FeatureFlag.ClientPortalRedesignInvestments,
  accounts: FeatureFlag.ClientPortalRedesignAccounts,
  tax: FeatureFlag.ClientPortalRedesignTax,
  documents: FeatureFlag.ClientPortalRedesignDocuments,
  planning: FeatureFlag.ClientPortalRedesignPlanning,
  accountProfile: FeatureFlag.ClientPortalRedesignAccountProfile,
  support: FeatureFlag.ClientPortalRedesignSupport,
};
